import { render, staticRenderFns } from "./DetailResult.vue?vue&type=template&id=382144d1&scoped=true"
import script from "./DetailResult.vue?vue&type=script&lang=js"
export * from "./DetailResult.vue?vue&type=script&lang=js"
import style0 from "./DetailResult.vue?vue&type=style&index=0&id=382144d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382144d1",
  null
  
)

export default component.exports